import React, { useState } from 'react';
import { Button } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import UploadStatus, { StatusName } from '@constants/uploadStatus';
import usePostUploadStatus from '@api/upload/hooks/usePostUploadStatus';
import { UploadDTO } from '@api/upload/dto/UploadDTO';
import { isContractor } from '@utils/UserRoleSelector';
import useGetUser from '@api/user/hooks/useGetUser';

type Props = {
  uploadDTO: UploadDTO;
};

function SendAndCancelOption({ uploadDTO }: Props) {
  const { t } = useTranslation();
  const [isSubmitDisabled, setIsSubmitDisabled] = useState<boolean>(false);
  const uploadStatus = UploadStatus[uploadDTO.status as StatusName];
  const changeFileSetStatus = usePostUploadStatus(() => {});
  const { data: user } = useGetUser();

  const canRender = UploadStatus.VALIDATED === uploadStatus;

  if (!user || !canRender || !isContractor(user)) {
    return null;
  }

  return (
    <>
      <Button
        content={t('upload.send')}
        icon="paper plane"
        labelPosition="left"
        positive
        onClick={() => {
          setIsSubmitDisabled(true);
          changeFileSetStatus({
            id: uploadDTO.id,
            status: UploadStatus.WAITING_FOR_ACCEPTANCE,
            reason: '',
          });
        }}
        disabled={isSubmitDisabled}
      />
      <Button
        content={t('button.cancel')}
        icon="close"
        labelPosition="left"
        negative
        onClick={() => {
          setIsSubmitDisabled(true);
          changeFileSetStatus({ id: uploadDTO.id, status: UploadStatus.CANCELLED, reason: '' });
        }}
        disabled={isSubmitDisabled}
      />
    </>
  );
}

export default SendAndCancelOption;
